export default __webpack_public_path__ + "static/media/image-intro-mobile.8b8c3185.jpg";